var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState, } from "react";
import { useNavigate } from "react-router";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { getFNOScripts } from "../../../apis/dashboard";
import { useAppDispatch } from "../../../hooks/redux";
import { FNO_ROLLOVER_SCRIPT_CODE } from "../../../utils/constant";
import styles from "./fo-momentum.module.scss";
import { dashboardWorkerRef } from "src/apis/dashboard.controller";
import { v4 as uuid } from "uuid";
import FinalGuestLogin from "src/components/final-guest-login/final-guest-login";
const { REACT_APP_ENV } = process.env;
const FOMomentum = React.forwardRef((_a, ref) => {
    var others = __rest(_a, []);
    const [scripts, setScripts] = useState([]);
    const [scriptsErr, setScriptsErr] = useState(false);
    const [feeds, setFeeds] = useState([]);
    const [feedErr, setFeedErr] = useState(false);
    const [feedDataSet, setFeedDataSet] = useState([
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ]);
    const dispatch = useAppDispatch();
    const fetchScript = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d, _e;
        try {
            const result = yield getFNOScripts(FNO_ROLLOVER_SCRIPT_CODE);
            setScripts((_e = (_d = (_c = (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.FNORollOverList) === null || _e === void 0 ? void 0 : _e.FNORollOverdata);
        }
        catch (err) {
            setScriptsErr(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), []);
    useEffect(() => {
        //fetchScript();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const searchUIDRef = useRef(uuid());
    const fetchMarketFeed = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h, _j, _k, _l, _m, _o;
        try {
            const getMarketFeedSliced = (start, end) => {
                var _a;
                return (_a = scripts.slice(start, end)) === null || _a === void 0 ? void 0 : _a.map((script, index) => {
                    let exDate = new Date(scripts[0]["ExpDate"])
                        .toDateString()
                        .substring(4, 15);
                    exDate = moment(exDate).format("DD MMM YYYY");
                    const exDateFormat = moment(exDate)
                        .format("YYYY MM DD")
                        .replace(/\s/g, "");
                    return {
                        Exch: "N",
                        ExchType: "D",
                        Symbol: `${script.Symbol} ${exDate}`,
                        Expiry: exDateFormat,
                        StrikePrice: "0",
                        OptionType: "XX",
                    };
                });
            };
            const promises = [
                [0, 50],
                [50, 100],
                [100, 150],
                [150, 200],
            ].map((arr, i) => {
                const body = {
                    MarketFeedData: getMarketFeedSliced(arr[0], arr[1]),
                    Count: getMarketFeedSliced(arr[0], arr[1]).length,
                    ClientLoginType: 0,
                    LastRequestTime: "/Date(0)/",
                    RefreshRate: "H",
                };
                // if (!isEmpty(body.MarketFeedData)) return getMarketFeedV6(body);
                if (!isEmpty(body.MarketFeedData))
                    return dashboardWorkerRef.getMarketFeedV6Impl(body, searchUIDRef.current + i);
            });
            const [result1, result2, result3, result4] = yield Promise.all(promises);
            const feeds1 = (_g = (_f = result1 === null || result1 === void 0 ? void 0 : result1.data) === null || _f === void 0 ? void 0 : _f.body) === null || _g === void 0 ? void 0 : _g.Data;
            const feeds2 = (_j = (_h = result2 === null || result2 === void 0 ? void 0 : result2.data) === null || _h === void 0 ? void 0 : _h.body) === null || _j === void 0 ? void 0 : _j.Data;
            const feeds3 = (_l = (_k = result3 === null || result3 === void 0 ? void 0 : result3.data) === null || _k === void 0 ? void 0 : _k.body) === null || _l === void 0 ? void 0 : _l.Data;
            const feeds4 = (_o = (_m = result4 === null || result4 === void 0 ? void 0 : result4.data) === null || _m === void 0 ? void 0 : _m.body) === null || _o === void 0 ? void 0 : _o.Data;
            const feeds = [...feeds1, ...feeds2, ...feeds3, ...feeds4];
            // const result = { data : getMarketFeedV6() };
            // const feeds = result.data.body.Data;
            setFeeds(feeds);
            const feedDataObj = {
                "-15": 0,
                "10-15": 0,
                "5-10": 0,
                "2-5": 0,
                "0-2": 0,
                "02": 0,
                "25": 0,
                "510": 0,
                "1015": 0,
                "15": 0,
            };
            feeds === null || feeds === void 0 ? void 0 : feeds.map((feed) => {
                // if (feed.LastRate && feed.PClose) {
                // AS per Rishab (LTP-Pclose)/Pclose*100
                const chnPrnt = feed.PClose == 0 || feed.LastRate == 0
                    ? 0
                    : ((feed.LastRate - feed.PClose) / feed.PClose) * 100;
                if (chnPrnt < -15) {
                    feedDataObj["-15"] = feedDataObj["-15"] + 1;
                }
                else if (chnPrnt >= -15 && chnPrnt <= -10) {
                    feedDataObj["10-15"] = feedDataObj["10-15"] + 1;
                }
                else if (chnPrnt >= -10 && chnPrnt <= -5) {
                    feedDataObj["5-10"] = feedDataObj["5-10"] + 1;
                }
                else if (chnPrnt >= -5 && chnPrnt <= -2) {
                    feedDataObj["2-5"] = feedDataObj["2-5"] + 1;
                }
                else if (chnPrnt >= -2 && chnPrnt <= 0) {
                    feedDataObj["0-2"] = feedDataObj["0-2"] + 1;
                }
                else if (chnPrnt >= 0 && chnPrnt <= 2) {
                    feedDataObj["02"] = feedDataObj["02"] + 1;
                }
                else if (chnPrnt >= 2 && chnPrnt <= 5) {
                    feedDataObj["25"] = feedDataObj["25"] + 1;
                }
                else if (chnPrnt >= 5 && chnPrnt <= 10) {
                    feedDataObj["510"] = feedDataObj["510"] + 1;
                }
                else if (chnPrnt >= 10 && chnPrnt <= 15) {
                    feedDataObj["1015"] = feedDataObj["1015"] + 1;
                }
                else if (chnPrnt > 15) {
                    feedDataObj["15"] = feedDataObj["15"] + 1;
                }
                // }
            });
            const feedDataClone = [
                feedDataObj["-15"],
                feedDataObj["10-15"],
                feedDataObj["5-10"],
                feedDataObj["2-5"],
                feedDataObj["0-2"],
                feedDataObj["02"],
                feedDataObj["25"],
                feedDataObj["510"],
                feedDataObj["1015"],
                feedDataObj["15"],
            ];
            setFeedDataSet(feedDataClone);
        }
        catch (err) {
            setFeedErr(true);
        }
    }), [scripts]);
    useEffect(() => {
        //fetchMarketFeed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scripts]);
    const total = feedDataSet.reduce((val, ac = 0) => ac + val);
    const declinersTotal = feedDataSet
        .slice(0, 5)
        .reduce((val, ac = 0) => ac + val);
    const advancersTotal = feedDataSet
        .slice(5, 10)
        .reduce((val, ac = 0) => ac + val);
    const declinersPerc = Math.floor((declinersTotal * 100) / total);
    const advancersPerc = Math.floor((advancersTotal * 100) / total);
    const navigate = useNavigate();
    const captureExpandClick = () => {
        captureCleverTabAnalytics("Expand_Click", {
            Initiation_Screen: "FnO_MOMENTUM",
        });
    };
    return (
    // <Profiler id={"Momentum"} onRender={onRenderCallback}>
    _jsx("div", Object.assign({ ref: ref }, others, { children: _jsxs("div", Object.assign({ className: styles.sectionBody }, { children: [_jsx("div", Object.assign({ className: `${styles.sectionHeader}` }, { children: _jsx("div", Object.assign({ className: "d-flex flex-grow-1" }, { children: _jsx("span", Object.assign({ className: `mediumWeight text-uppercase ${styles.sectionTitle}` }, { children: `F&O Momentum` })) })) })), _jsx(FinalGuestLogin, {})] })) }))
    // </Profiler>
    );
});
FOMomentum.displayName = "FOMomentum";
export default FOMomentum;
